export default __webpack_public_path__ + "static/bg-cta-00dedf81e56022c35187f988d11c36d7.webp";